/**
 *
 * ReminderEmails
 *
 */

import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { isEqual, pick } from "lodash"
import Loader from "components/Loader"
import { Button, Switch, Divider, Radio } from "antd"
import reducer from "./reducer"
import saga from "./saga"
import alertSvg from "images/alert.svg"
import ModalCustom from "components/ModalCustom"

import {
  getConfigurationWatcher,
  getConfigurationSuccess,
  putConfigurationWatcher,
} from "./actions"
import {
  makeSelectConfigurationObject,
  makeSelectIsLoadingConfiguration,
  makeSelectIsLoading,
} from "./selectors"

import "./index.less"
import { isModuleBySlug,LOCAL_PDA_IA_ENABLED } from "../../../utils/storage"
import {
  ACTION_PLANS,
  AMBASSADOR_USERS,
  LEADER_USERS,
} from "../../../utils/constants"
import { buttonAction_btns } from "../../../components/Snowplow/config2"

/* eslint-disable react/prefer-stateless-function */
export class ReminderEmails extends React.Component {
  firstLoad = true
  state = {
    mail_administrator_general_reminders: false,
    mail_administrator_results: false,
    mail_administrator_weekly_status: false,
    mail_ambassador_assigned_action_plans_status: false,
    mail_ambassador_general_reminders: false,
    mail_ambassador_results: false,
    mail_non_user_assigned_task_status: false,
    mail_non_user_general_reminders: false,
    mail_leader_results: false,
    mail_administrator: false,
    mail_ambassador: false,
    mail_non_user: false,
    mail_leader: false,

    showModal: false,
    switch_administrator_state_label: "Prender",
    switch_ambassador_state_label: "Prender",
    switch_collaborator_state_label: "Prender",
    switch_boss_state_label: "Prender",
    setRol: "",
    disabled_switch: false,
  }

  componentDidMount = () => {
    this.props.getConfigurationWatcher()
  }

  componentWillUnmount = () => {
    this.props.getConfigurationSuccess({})
    this.firstLoad = true
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (!isEqual(prevProps.configuration, this.props.configuration)) {
      this.setStateFromProps()
      this.firstLoad = false
    }

    let {
      mail_administrator_weekly_status,
      mail_administrator_general_reminders,
      mail_administrator_results,
      mail_ambassador_assigned_action_plans_status,
      mail_ambassador_general_reminders,
      mail_ambassador_results,
      mail_non_user_assigned_task_status,
      mail_non_user_general_reminders,
      mail_leader_results,
    } = this.state

    /*  eslint-disable-next-line */
    if (
      prevState.mail_administrator_weekly_status !==
        mail_administrator_weekly_status ||
      prevState.mail_administrator_general_reminders !==
        mail_administrator_general_reminders ||
      prevState.mail_administrator_results !== mail_administrator_results
    ) {
      this.loadStateSwitch()
    }

    /*  eslint-disable-next-line */
    if (
      prevState.mail_ambassador_assigned_action_plans_status !==
        mail_ambassador_assigned_action_plans_status ||
      prevState.mail_ambassador_general_reminders !==
        mail_ambassador_general_reminders ||
      prevState.mail_ambassador_results !== mail_ambassador_results
    ) {
      this.loadStateSwitch()
    }

    /*  eslint-disable-next-line */
    if (
      prevState.mail_non_user_assigned_task_status !==
        mail_non_user_assigned_task_status ||
      prevState.mail_non_user_general_reminders !==
        mail_non_user_general_reminders
    ) {
      this.loadStateSwitch()
    }

    /*  eslint-disable-next-line */
    if (prevState.mail_leader_results !== mail_leader_results) {
      this.loadStateSwitch()
    }
  }

  setStateFromProps = () => {
    const {
      mail_administrator_general_reminders,
      mail_administrator_results,
      mail_administrator_weekly_status,
      mail_ambassador_assigned_action_plans_status,
      mail_ambassador_general_reminders,
      mail_ambassador_results,
      mail_non_user_assigned_task_status,
      mail_non_user_general_reminders,
      mail_leader_results,
      mail_administrator,
      mail_ambassador,
      mail_non_user,
      mail_leader,
    } = this.props.configuration

    this.setState({
      mail_administrator_general_reminders,
      mail_administrator_results,
      mail_administrator_weekly_status,
      mail_ambassador_assigned_action_plans_status,
      mail_ambassador_general_reminders,
      mail_ambassador_results,
      mail_non_user_assigned_task_status,
      mail_non_user_general_reminders,
      mail_leader_results,
      mail_administrator,
      mail_ambassador,
      mail_non_user,
      mail_leader,
    })
  }

  setStateFrom = (name, value) => {
    this.setState({ [name]: value })
    this.setState({ disabled_switch: value })
  }

  validateChangeFooter = () => {
    if (!this.props.configuration) return

    const {
      mail_administrator_general_reminders,
      mail_administrator_results,
      mail_administrator_weekly_status,
      mail_ambassador_assigned_action_plans_status,
      mail_ambassador_general_reminders,
      mail_ambassador_results,
      mail_non_user_assigned_task_status,
      mail_non_user_general_reminders,
      mail_leader_results,
      mail_administrator,
      mail_ambassador,
      mail_non_user,
      mail_leader,
    } = this.props.configuration
    const stateContent = {
      mail_administrator_general_reminders: this.state
        .mail_administrator_general_reminders,
      mail_administrator_results: this.state.mail_administrator_results,
      mail_administrator_weekly_status: this.state
        .mail_administrator_weekly_status,
      mail_ambassador_assigned_action_plans_status: this.state
        .mail_ambassador_assigned_action_plans_status,
      mail_ambassador_general_reminders: this.state
        .mail_ambassador_general_reminders,
      mail_ambassador_results: this.state.mail_ambassador_results,
      mail_non_user_assigned_task_status: this.state
        .mail_non_user_assigned_task_status,
      mail_non_user_general_reminders: this.state
        .mail_non_user_general_reminders,
      mail_leader_results: this.state.mail_leader_results,
      mail_administrator: this.state.mail_administrator,
      mail_ambassador: this.state.mail_ambassador,
      mail_non_user: this.state.mail_non_user,
      mail_leader: this.state.mail_leader,
    }

    const propsContent = {
      mail_administrator_general_reminders,
      mail_administrator_results,
      mail_administrator_weekly_status,
      mail_ambassador_assigned_action_plans_status,
      mail_ambassador_general_reminders,
      mail_ambassador_results,
      mail_non_user_assigned_task_status,
      mail_non_user_general_reminders,
      mail_leader_results,
      mail_administrator,
      mail_ambassador,
      mail_non_user,
      mail_leader,
    }

    return !isEqual(stateContent, propsContent)
  }

  sendToServer = () => {
    const {
      mail_administrator_general_reminders,
      mail_administrator_results,
      mail_administrator_weekly_status,
      mail_ambassador_assigned_action_plans_status,
      mail_ambassador_general_reminders,
      mail_ambassador_results,
      mail_non_user_assigned_task_status,
      mail_non_user_general_reminders,
      mail_leader_results,
      disabled_switch,
      mail_administrator,
      mail_ambassador,
      mail_non_user,
      mail_leader,
    } = this.state
    const stateContent = {
      mail_administrator_general_reminders: Number(
        mail_administrator_general_reminders
      ),
      mail_administrator_results: Number(mail_administrator_results),
      mail_administrator_weekly_status: Number(
        mail_administrator_weekly_status
      ),
      mail_ambassador_assigned_action_plans_status: Number(
        mail_ambassador_assigned_action_plans_status
      ),
      mail_ambassador_general_reminders: Number(
        mail_ambassador_general_reminders
      ),
      mail_ambassador_results: Number(mail_ambassador_results),
      mail_non_user_assigned_task_status: Number(
        mail_non_user_assigned_task_status
      ),
      mail_non_user_general_reminders: Number(mail_non_user_general_reminders),
      mail_leader_results: Number(mail_leader_results),
      switchMaster: disabled_switch,

      mail_administrator: Number(mail_administrator),
      mail_ambassador: Number(mail_ambassador),
      mail_non_user: Number(mail_non_user),
      mail_leader: Number(mail_leader),
    }

    this.props.putConfigurationWatcher(stateContent)
  }

  closeModal = () => {
    this.setState({ showModal: false })
    this.setStateFromProps()
  }

  savedService = () => {
    let { setRol, disabled_switch } = this.state

    if (setRol === "Administrador") {
      this.setState({
        mail_administrator: false,
        switch_administrator_state_label: "Prender",
        switchMaster: disabled_switch,
      })
      this.setState({
        mail_administrator_weekly_status: false,
        mail_administrator_general_reminders: false,
        mail_administrator_results: false,
        switchMaster: disabled_switch,
      })
    }

    if (setRol === "Embajador") {
      this.setState({
        mail_ambassador: false,
        switch_ambassador_state_label: "Prender",
      })
      this.setState({
        mail_ambassador_assigned_action_plans_status: false,
        mail_ambassador_general_reminders: false,
        mail_ambassador_results: false,
        switchMaster: disabled_switch,
      })
    }

    if (setRol === "Colaborador") {
      this.setState({
        mail_non_user: false,
        switch_collaborator_state_label: "Prender",
      })
      this.setState({
        mail_non_user_assigned_task_status: false,
        mail_non_user_general_reminders: false,
        switchMaster: disabled_switch,
      })
    }

    if (setRol === "Líder") {
      this.setState({
        mail_leader: false,
        switch_boss_state_label: "Prender",
      })
      this.setState({
        mail_leader_results: false,
        switchMaster: disabled_switch,
      })
    }

    this.setState({ showModal: false })
  }

  setStateSwitchAdmin = (value) => {
    this.setState({
      setRol: "Administrador",
    })
    if (value === false) {
      this.setState({ showModal: true })
    } else {
      this.setState({
        mail_administrator: value,
        switch_administrator_state_label: "Apagar",
      })
      this.setState({
        mail_administrator_weekly_status: true,
        mail_administrator_general_reminders: true,
        mail_administrator_results: true,
      })
    }
    this.setState({ disabled_switch: value })
  }

  setStateSwitchAmbassador = (value) => {
    this.setState({
      setRol: "Embajador",
    })
    if (value === false) {
      this.setState({ showModal: true })
    } else {
      this.setState({
        mail_ambassador: value,
        switch_administrator_state_label: "Apagar",
      })
      this.setState({
        mail_ambassador_assigned_action_plans_status: true,
        mail_ambassador_general_reminders: true,
        mail_ambassador_results: true,
      })
    }
    this.setState({ disabled_switch: value })
  }

  setStateSwitchCollaborator = (value) => {
    this.setState({
      setRol: "Colaborador",
    })
    if (value === false) {
      this.setState({ showModal: true })
    } else {
      this.setState({
        mail_non_user: value,
        switch_collaborator_state_label: "Apagar",
      })
      this.setState({
        mail_non_user_assigned_task_status: true,
        mail_non_user_general_reminders: true,
      })
    }
    this.setState({ disabled_switch: value })
  }

  setStateSwitchBoss = (value) => {
    this.setState({
      setRol: "Líder",
    })
    if (value === false) {
      this.setState({ showModal: true })
    } else {
      this.setState({
        mail_leader: value,
        switch_boss_state_label: "Apagar",
      })
      this.setState({
        mail_leader_results: true,
      })
    }
    this.setState({ disabled_switch: value })
  }

  loadStateSwitch = () => {
    let {
      mail_administrator_weekly_status,
      mail_administrator_general_reminders,
      mail_administrator_results,
      mail_ambassador_assigned_action_plans_status,
      mail_ambassador_general_reminders,
      mail_ambassador_results,
      mail_non_user_assigned_task_status,
      mail_non_user_general_reminders,
      mail_leader_results,
    } = this.state

    /*  eslint-disable-next-line */
    if (
      mail_administrator_weekly_status ||
      mail_administrator_general_reminders ||
      mail_administrator_results
    ) {
      this.setState({
        switch_administrator_state_label: "Apagar",
        mail_administrator: true,
      })
    }

    /*  eslint-disable-next-line */
    if (
      mail_ambassador_assigned_action_plans_status ||
      mail_ambassador_general_reminders ||
      mail_ambassador_results
    ) {
      this.setState({
        switch_ambassador_state_label: "Apagar",
        mail_ambassador: true,
      })
    }

    /*  eslint-disable-next-line */
    if (mail_non_user_assigned_task_status || mail_non_user_general_reminders) {
      this.setState({
        switch_collaborator_state_label: "Apagar",
        mail_non_user: true,
      })
    }

    /*  eslint-disable-next-line */
    if (mail_leader_results) {
      this.setState({
        switch_boss_state_label: "Apagar",
        mail_leader: true,
      })
    }
  }

  render() {
    let estado_result
    let estado_lider
    let estado_colaborador
    let estado_admin
    let {
      mail_administrator,
      switch_administrator_state_label,
      mail_ambassador,
      switch_ambassador_state_label,
      mail_non_user,
      switch_collaborator_state_label,
      mail_leader,
      switch_boss_state_label,
      setRol,
    } = this.state
    if (this.props.isLoadingConfiguration && this.firstLoad) {
      return <Loader height="80vh" />
    }

    let hasRole = {
      Administrador: "administradores",
      Embajador: "embajadores",
      Líder: "líderes",
      Colaborador: "colaboradores",
    }
    const isAmbassador = isModuleBySlug(AMBASSADOR_USERS)
    const isLeader = isModuleBySlug(LEADER_USERS)
    const isActionPlans = isModuleBySlug(ACTION_PLANS)
    return (
      <>
        <div className="container-reminderemails">
          <div style={{ display: "flex" }}>
            <div className="container-reminderemails__title color-gray-low">
              ADMINISTRADOR
            </div>
            <div className="container-switch">
              {`${switch_administrator_state_label} todos (Administrador)`}
              <Switch
                checked={mail_administrator}
                onChange={(e) => {
                  e == true
                    ? (estado_admin = "Activar")
                    : (estado_admin = "Desactivar")
                  buttonAction_btns(
                    `Correos recordatorios - Switch ${estado_admin} Apagar todos (administrador)`
                  )
                  this.setStateSwitchAdmin(e)
                }}
              />
            </div>
          </div>
          <div className="container-reminderemails__item">
            <Switch
              checked={this.state.mail_administrator_weekly_status}
              onChange={(e) => {
                this.setStateFrom("mail_administrator_weekly_status", e)
              }}
            />
            <div>
              <div className="container-reminderemails__item-title">
                Reporte de status semanal
              </div>
              <p>Reporte semanal con el status de las mediciones en curso.</p>
              <div className="container-reminderemails__item-footer">
                <span className="container-reminderemails__item-title">
                  Periodicidad
                </span>
                <span className="container-reminderemails__item-footer-all">
                  Todos los
                </span>
                <Radio.Group defaultValue="monday" disabled>
                  <Radio.Button value="monday">Lunes</Radio.Button>
                </Radio.Group>
              </div>
            </div>
          </div>
          <Divider />
          <div className="container-reminderemails__item">
            <Switch
              checked={this.state.mail_administrator_general_reminders}
              onChange={(e) => {
                this.setStateFrom("mail_administrator_general_reminders", e)
                e == true
                  ? (estado_result = "Activar")
                  : (estado_result = "Desactivar")
                buttonAction_btns(
                  `Correos recordatorios administrador- Switch ${estado_result} Recordatorios generales`
                )
              }}
            />
            <div>
              <div className="container-reminderemails__item-title">
              Recordatorios y envíos generales
              </div>
              <p>
              Recordatorios de inicio y fin de las mediciones, recomendaciones de extensión
              de mediciones y establecimiento de contraseñas de usuarios administradores.
              </p>
            </div>
          </div>
          <Divider />
          <div className="container-reminderemails__item">
            <Switch
              checked={this.state.mail_administrator_results}
              onChange={(e) => {
                e == true
                  ? (estado_result = "Activar")
                  : (estado_result = "Desactivar")
                buttonAction_btns(
                  `Correos recordatorios administrador- Switch ${estado_result} resultados`
                )
                this.setStateFrom("mail_administrator_results", e)
              }}
            />
            <div>
              <div className="container-reminderemails__item-title">
                Resultados
              </div>
              <p>
                Resultados de las mediciones oficializadas en formato Excel y
                PDF.
              </p>
            </div>
          </div>

          {isAmbassador && (
            <Fragment>
              <div style={{ display: "flex" }}>
                <div
                  className="container-reminderemails__title color-gray-low"
                  style={{ marginTop: 24 }}>
                  EMBAJADOR
                </div>
                <div style={{ marginTop: 24 }} className="container-switch">
                  {`${switch_ambassador_state_label} todos (Embajador)`}
                  <Switch
                    checked={mail_ambassador}
                    onChange={(e) => {
                      e == true
                        ? (estado_colaborador = "Activar")
                        : (estado_colaborador = "Desactivar")
                      buttonAction_btns(
                        `Correos recordatorios - Switch ${estado_colaborador} Apagar todos (embajador)`
                      )
                      this.setStateSwitchAmbassador(e)
                    }}
                  />
                </div>
              </div>
              {isActionPlans && (
                <Fragment>
                  <div className="container-reminderemails__item">
                    <Switch
                      checked={
                        this.state.mail_ambassador_assigned_action_plans_status
                      }
                      onChange={(e) => {
                        e == true
                          ? (estado_result = "Activar")
                          : (estado_result = "Desactivar")
                        buttonAction_btns(
                          `Correos recordatorios embajador- Switch ${estado_result} Asignación de planes de acción y tareas`
                        )
                        this.setStateFrom(
                          "mail_ambassador_assigned_action_plans_status",
                          e
                        )
                      }}
                    />
                    <div>
                      <div className="container-reminderemails__item-title">
                        Asignación de planes de acción y tareas
                      </div>
                      <p>
                        Compilado de planes de acción y tareas de los que has
                        sido asignado como responsable.
                      </p>
                    </div>
                  </div>
                  <Divider />
                </Fragment>
              )}
              {isActionPlans && (
                <Fragment>
                  <div className="container-reminderemails__item">
                    <Switch
                      checked={this.state.mail_ambassador_general_reminders}
                      onChange={(e) => {
                        e == true
                          ? (estado_result = "Activar")
                          : (estado_result = "Desactivar")
                        buttonAction_btns(
                          `Correos recordatorios embajador - Switch ${estado_result} Recordatorios generales`
                        )
                        this.setStateFrom(
                          "mail_ambassador_general_reminders",
                          e
                        )
                      }}
                    />
                    <div>
                      <div className="container-reminderemails__item-title">
                        Recordatorios generales
                      </div>
                      <p>
                        Recordatorios de planes de acción y tareas próximos a
                        vencer.
                      </p>
                    </div>
                  </div>
                  <Divider />
                </Fragment>
              )}

              <div className="container-reminderemails__item">
                <Switch
                  checked={this.state.mail_ambassador_results}
                  onChange={(e) => {
                    e == true
                      ? (estado_result = "Activar")
                      : (estado_result = "Desactivar")
                    buttonAction_btns(
                      `Correos recordatorios embajador- Switch ${estado_result} resultados`
                    )
                    this.setStateFrom("mail_ambassador_results", e)
                  }}
                />
                <div>
                  <div className="container-reminderemails__item-title">
                    Resultados
                  </div>
                  <p>
                  Una vez que la medición ha sido oficializada por el administrador,
                   el usuario embajador recibirá los resultados correspondientes a 
                   su equipo en formato Excel y PDF. {LOCAL_PDA_IA_ENABLED() ? 'Además recibirá una invitación a crear planes sobre los resultados.': ''}  
             
                  </p>
                </div>
              </div>
              <Divider />

              <div style={{ display: "flex" }}>
                <div
                  className="container-reminderemails__title color-gray-low"
                  style={{ marginTop: 24 }}>
                  COLABORADOR
                </div>
                <div style={{ marginTop: 24 }} className="container-switch">
                  {`${switch_collaborator_state_label} todos (Colaborador)`}
                  <Switch
                    checked={mail_non_user}
                    onChange={(e) => {
                      e == true
                        ? (estado_colaborador = "Activar")
                        : (estado_colaborador = "Desactivar")
                      buttonAction_btns(
                        `Correos recordatorios - Switch ${estado_colaborador} Apagar todos (colaborador)`
                      )
                      this.setStateSwitchCollaborator(e)
                    }}
                  />
                </div>
              </div>
              {isActionPlans && (
                <Fragment>
                  <div className="container-reminderemails__item">
                    <Switch
                      checked={this.state.mail_non_user_assigned_task_status}
                      onChange={(e) => {
                        e == true
                          ? (estado_colaborador = "Activar")
                          : (estado_colaborador = "Desactivar")
                        buttonAction_btns(
                          `Correos recordatorios Colaborador - Switch ${estado_colaborador} Asignación de tareas`
                        )
                        this.setStateFrom(
                          "mail_non_user_assigned_task_status",
                          e
                        )
                      }}
                    />
                    <div>
                      <div className="container-reminderemails__item-title">
                        Asignación de tareas
                      </div>
                      <p>
                        Compilado de tareas a las que has sido asignado como
                        responsable.
                      </p>
                    </div>
                  </div>
                  <Divider />
                </Fragment>
              )}
              {isActionPlans && (
                <Fragment>
                  <div className="container-reminderemails__item">
                    <Switch
                      checked={this.state.mail_non_user_general_reminders}
                      onChange={(e) => {
                        e == true
                          ? (estado_result = "Activar")
                          : (estado_result = "Desactivar")
                        buttonAction_btns(
                          `Correos recordatorios lider - Switch ${estado_result} Recordatorios generales `
                        )
                        this.setStateFrom("mail_non_user_general_reminders", e)
                      }}
                    />
                    <div>
                      <div className="container-reminderemails__item-title">
                        Recordatorios generales
                      </div>
                      <p>Recordatorios de tareas próximas a vencer.</p>
                    </div>
                  </div>
                </Fragment>
              )}
            </Fragment>
          )}

          {isLeader && (
            <>
              <div style={{ display: "flex" }}>
                <div
                  className="container-reminderemails__title color-gray-low"
                  style={{ marginTop: 24 }}>
                  LÍDER
                </div>
                <div style={{ marginTop: 24 }} className="container-switch">
                  {`${switch_boss_state_label} todos (Líder)`}
                  <Switch
                    checked={mail_leader}
                    onChange={(e) => {
                      e == true
                        ? (estado_lider = "Activar")
                        : (estado_lider = "Desactivar")
                      buttonAction_btns(
                        `Correos recordatorios - Switch ${estado_lider} Apagar todos (líder)`
                      )
                      this.setStateSwitchBoss(e)
                    }}
                  />
                </div>
              </div>
              <div
                className="container-reminderemails__item"
                style={{ marginBottom: "5rem" }}>
                <Switch
                  checked={this.state.mail_leader_results}
                  onChange={(e) => {
                    e == true
                      ? (estado_result = "Activar")
                      : (estado_result = "Desactivar")
                    buttonAction_btns(
                      `Correos recordatorios lider- Switch ${estado_result} resultados`
                    )
                    this.setStateFrom("mail_leader_results", e)
                  }}
                />
                <div>
                  <div className="container-reminderemails__item-title">
                    Resultados
                  </div>
                  <p>
                    Una vez que la medición ha sido oficializada por el
                    administrador, el líder recibirá los resultados
                    correspondientes a su equipo en formato Excel y PDF.
                  </p>
                </div>
              </div>
              <Divider />
            </>
          )}

          {this.validateChangeFooter() && (
            <div className="container-reminderemails__action">
              <Button onClick={this.setStateFromProps}>Cancelar</Button>
              <Button
                onClick={this.sendToServer}
                type="primary"
                loading={this.props.isLoadingConfiguration}>
                Guardar
              </Button>
            </div>
          )}
        </div>
        <ModalCustom
          onCancel={() => this.closeModal()}
          onOk={() => this.savedService()}
          modalOpen={this.state.showModal}
          showFooter
          isLoadingButton={this.props.isLoadingConfiguration}
          okType="primary"
          textButton="Desactivar">
          <div className="component-deletesimple">
            <img src={alertSvg} className="alertIcon" />
            <div className="modal-warning-switch">
              ¿Estás seguro de que deseas desactivar el envío de correos a los
              usuarios {hasRole[setRol] || ""} de tu plataforma?
            </div>
          </div>
        </ModalCustom>
      </>
    )
  }
}

ReminderEmails.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  configuration: makeSelectConfigurationObject(),
  isLoadingConfiguration: makeSelectIsLoadingConfiguration(),
})

function mapDispatchToProps(dispatch) {
  return {
    getConfigurationWatcher: () => dispatch(getConfigurationWatcher()),
    getConfigurationSuccess: () => dispatch(getConfigurationSuccess()),
    putConfigurationWatcher: (params) =>
      dispatch(putConfigurationWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "reminderEmails", reducer })
const withSaga = injectSaga({ key: "reminderEmails", saga })

export default compose(withReducer, withSaga, withConnect)(ReminderEmails)
